import {
  type DefaultOptions,
  QueryClient,
  type UseMutationOptions,
  type UseQueryOptions,
} from "@tanstack/react-query";
import type { AxiosError } from "axios";

const queryConfig: DefaultOptions = {
  queries: {
    staleTime: 5 * 60 * 1000, // 5分間フレッシュ
    gcTime: 10 * 60 * 1000, // 10分間キャッシュ保持
    refetchOnWindowFocus: false,
    retry: false, // 既存のaxiosインターセプターに委譲
  },
};

export const queryClient = new QueryClient({
  defaultOptions: queryConfig,
});

export type ExtractFnReturnType<
  FnType extends (...args: unknown[]) => unknown,
> = Awaited<ReturnType<FnType>>;

export type QueryConfig<QueryFnType extends (...args: unknown[]) => unknown> =
  Omit<
    UseQueryOptions<ExtractFnReturnType<QueryFnType>>,
    "queryKey" | "queryFn"
  >;

export type MutationConfig<
  MutationFnType extends (...args: unknown[]) => unknown,
> = UseMutationOptions<
  ExtractFnReturnType<MutationFnType>,
  AxiosError,
  Parameters<MutationFnType>[0]
>;
